export const DATA_CENTER_HEADER = "Survey Data Center";
export const DATA_CENTER_SUBTITLE =
  "Track growth and leadership trends over time for each teacher. Data is sorted by teacher self survey (red) and by group average (blue) over time. ";

export const TOGGLE_LABEL = "Show / Hide Teachers";
export const TOGGLE_LABEL_AD = "Show / Hide School Admins";
export const SELECT_LABEL = "Select a Teacher";
export const SELECT_LABEL_AD = "Select a School Admin";
export const SHOW_INACTIVE_LABEL = "Show Inactive";
export const ONLY_SHOW_INACTIVE_LABEL = "Only Show Inactive";

export const DEFAULT_COACH_ID = -1;

export const NO_SELECT = "None";

export const ERROR_MESSAGE =
  "An error occured on the server. Please try again.";



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/constants.ts